/**
 * Configuration for device capability detection thresholds
 * Used to determine device performance levels (LOW, MEDIUM, HIGH)
 */
export const deviceCapabilitiesConfig = {
  lowCPUCoresThreshold: 6,
  highCPUCoresThreshold: 8,
  lowMemoryThreshold: 4, // GB
  highMemoryThreshold: 8, // GB
  minTextureSize: 4096,
  minVertexUniformVectors: 1024,
  slowDeviceThreshold: 12, // milliseconds (reduced from 100ms for better accuracy with statistical benchmarking)
  minRefreshRateForHighEnd: 90, // Hz
  lowBatteryThreshold: 20, // percentage (informational only, not used for scoring)
  enableAnimationsForLowEnd: false,
  // Benchmarking configuration
  benchmarkRounds: 11, // Number of benchmark rounds for statistical analysis
  benchmarkWarmupIterations: 1e5, // Warmup iterations to trigger JIT compilation
  benchmarkIterations: 5e6, // Iterations per benchmark round
  minValidBenchmarkResults: 5, // Minimum valid results required for analysis
} as const;
